import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/content';
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [purchase, setPurchase] = useState(purchases[0]);
  useEffect(() => {
    const showPopup = () => {
      setPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 6500);
    };
    const initialTimer = window.setTimeout(showPopup, 3500);
    const interval = window.setInterval(showPopup, 18000);
    return () => {
      window.clearTimeout(initialTimer);
      window.clearInterval(interval);
    };
  }, []);
  if (!visible) return null;
  return <aside className="pointer-events-none fixed bottom-3 left-3 right-3 z-50 flex animate-slide-in justify-center sm:left-auto sm:right-4 sm:justify-end" aria-live="polite" data-id="element-149" data-mp="3iqtqowe1axuw">
      <div className="pointer-events-auto relative w-full max-w-[290px] overflow-hidden rounded-lg border-2 border-brand-green bg-brand-navy p-2.5 pr-7 text-white shadow-[0_8px_24px_rgba(6,35,61,0.45)]" data-id="element-150" data-mp="1gyng79oug6ia">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-green" data-id="element-151" data-mp="116mgstdueq5i" />
        <button onClick={() => setVisible(false)} aria-label="Fermer la notification" className="absolute right-1.5 top-1.5 rounded p-0.5 text-white/60 hover:text-white focus:outline-none focus:ring-2 focus:ring-brand-green" data-id="element-152" data-mp="1fur2m686zhsi">
          <XIcon className="h-3.5 w-3.5" data-id="element-153" data-mp="i8a5b0zgl46r" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-154" data-mp="i9v1sw5c2x79">
          <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-brand-green bg-brand-green/20" data-id="element-155" data-mp="x5u8q3gpirat">
            <ShoppingBagIcon className="h-4 w-4 text-brand-green" aria-hidden="true" data-id="element-156" data-mp="s4mzdzyx1k21" />
          </div>
          <div className="leading-tight" data-id="element-157" data-mp="28iwnqu35r8sv">
            <p className="text-[11px] font-bold" data-id="element-158" data-mp="23ln1fnb2fd99">{purchase.name}</p>
            <p className="text-[10px] font-medium text-white/70" data-id="element-159" data-mp="23l3ettah00ow">{purchase.location}</p>
            <p className="mt-0.5 text-[10px] font-extrabold uppercase text-brand-green" data-id="element-160" data-mp="2ao1ql7w3o7ui">
              vient d&apos;acheter PADEL COACH READY™
            </p>
          </div>
        </div>
      </div>
    </aside>;
}